export default __webpack_public_path__ + "7da01487ffc4869c9bee4d591abff089.svg";